var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006BC0"
    },
    d: "M512,256c0,141.385-114.615,256-256,256S0,397.385,0,256S114.615,0,256,0 c130.497,0,238.184,97.646,253.994,223.859c1.149,9.122,1.818,18.39,1.964,27.784C511.99,253.095,512,254.548,512,256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M511.958,251.643c-21.859,26.624-64.69,24.545-64.69,24.545 c-26.415,113.8-185.94,171.719-296.699,143.266C39.821,391.011,55.056,258.915,55.056,258.915h324.138 c26.749,0,28.787-8.129,28.787-8.129c-23.709-56.226,12.873-86.371,12.873-86.371c28.453,5.089,35.558,53.854,35.558,53.854 c23.353-4.19,42.109,0.794,53.582,5.59C511.143,232.981,511.812,242.249,511.958,251.643z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.6,
    y: 207.433,
    style: {
      fill: "#F2F2F2"
    },
    width: 45.39,
    height: 41.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.641,
    y: 207.433,
    style: {
      fill: "#F2F2F2"
    },
    width: 45.39,
    height: 41.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.743,
    y: 207.433,
    style: {
      fill: "#F2F2F2"
    },
    width: 45.39,
    height: 41.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.712,
    y: 207.433,
    style: {
      fill: "#F2F2F2"
    },
    width: 45.39,
    height: 41.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.712,
    y: 101.763,
    style: {
      fill: "#F2F2F2"
    },
    width: 45.39,
    height: 41.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.671,
    y: 207.433,
    style: {
      fill: "#F2F2F2"
    },
    width: 45.39,
    height: 41.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.641,
    y: 154.593,
    style: {
      fill: "#F2F2F2"
    },
    width: 45.39,
    height: 41.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.712,
    y: 154.593,
    style: {
      fill: "#F2F2F2"
    },
    width: 45.39,
    height: 41.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.671,
    y: 154.593,
    style: {
      fill: "#F2F2F2"
    },
    width: 45.39,
    height: 41.32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24);
export default __webpack_public_path__ + "static/media/icon24.f8dcee51ce14a8cf9fbd4a8168c6488f.svg";
export { ForwardRef as ReactComponent };